import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import ViewStationaryCartModal from "../../Components/ViewStationaryCartModal";
import { useCartStore } from "../../store/useStore";
import axios from "../../axios";
import { useTranslation } from "react-i18next";
import Currency from "../../Components/Currency";
import TaxInclusive from "../../Components/TaxInclusive.";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Toast } from "primereact/toast";
import ReactGA from "react-ga4";

function StationaryOrderPayment() {
  const toast = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const room_uuid = location.pathname.split("/")[1];
  const lang = sessionStorage.getItem("lang");
  const currency = localStorage.getItem("currency");
  const room_number = localStorage.getItem("room_number");

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [itemChange, setItemChange] = useState(null);
  const [title, setTitle] = useState("Stationary");
  const [services, setServices] = useState([]);
  const [images, setImages] = useState([]);
  const [serviceFee, setServiceFee] = useState(0);
  const [vat, setVat] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [minAmount, setMinAmount] = useState(0);
  const [disclaimerHtml, setDisclaimerHtml] = useState("");
  const [termsHtml, setTermsHtml] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [openMin, setOpenMin] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const { stationaryCart, setStationaryCart } = useCartStore((state) => ({
    stationaryCart: state.stationaryCart,
    setStationaryCart: state.setStationaryCart,
  }));

  useEffect(() => {
    if (!stationaryCart?.length) {
      navigate(`/${room_uuid}/Stationary`);
    }
  }, [stationaryCart?.length, navigate, room_uuid]);

  useEffect(() => {
    axios
      .get(`/${room_uuid}/stationary`, {
        headers: { lang },
      })
      .then((res) => {
        if (res?.data?.status) {
          const pageData = res?.data?.data || {};
          setTitle(pageData?.title || "Stationary");
          setServices(pageData?.stationaryServices || []);
          setImages(pageData?.banners || pageData?.header_images || []);
          setServiceFee(
            Number(
              pageData?.stationary?.service_fee || pageData?.service_fee || 0,
            ),
          );
          setVat(Number(pageData?.stationary?.vat || pageData?.vat || 0));
          setDiscountPercentage(
            Number(
              pageData?.stationary?.discount_percentage ||
                pageData?.discount_percentage ||
                0,
            ),
          );
          setMinAmount(
            Number(
              pageData?.stationary?.min_amount || pageData?.min_amount || 0,
            ),
          );
          setDisclaimerHtml(pageData?.disclaimers_name || "");
          setTermsHtml(pageData?.termsAndCondition_name || "");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [room_uuid, lang]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const removeItem = (item) => {
    const tempItems = stationaryCart.filter(
      (cartItem) => cartItem.id !== item.id,
    );
    setStationaryCart(tempItems);
    if (tempItems.length === 0) {
      navigate(`/${room_uuid}/Stationary`);
    }
  };

  const changeItem = (item) => {
    setItemChange(item);
    handleShow();
  };

  const addMoreItem = () => {
    ReactGA.event({
      category: "Click on Add more Item in stationary page ",
      action: "Click",
      value: ``,
    });
    setItemChange(null);
    handleShow();
  };

  const subTotal = stationaryCart.reduce(
    (sum, item) => sum + Number(item?.price || 0) * Number(item?.quantity || 0),
    0,
  );
  const discountedSubTotal = discountPercentage
    ? subTotal - subTotal * Number(discountPercentage / 100)
    : subTotal;
  const totalPrice = Number(discountedSubTotal) + Number(serviceFee || 0);
  const finalTotal = totalPrice + (totalPrice * Number(vat || 0)) / 100;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTermsClose = () => setShowTerms(false);
  const handleCloseMin = () => setOpenMin(false);

  const handleBook = (e) => {
    e.preventDefault();
    if (!stationaryCart?.length) {
      return;
    }

    if (minAmount > finalTotal) {
      setOpenMin(true);
      return;
    }

    setLoading(true);
    setIsDisabled(true);

    const payload = new URLSearchParams();
    stationaryCart.forEach((item, index) => {
      payload.append(`services[${index}][category_id]`, item.category_id);
      payload.append(
        `services[${index}][service_id]`,
        item.service_id || item.id,
      );
      payload.append(`services[${index}][quantity]`, item.quantity);
    });
    payload.append("name", formData.name || "");
    payload.append("email", formData.email || "");
    payload.append("phone", formData.phone || "");

    axios
      .post(`/${room_uuid}/stationary/book_service`, payload, {
        headers: {
          lang,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        setLoading(false);
        setIsDisabled(false);
        if (res?.data?.status) {
          ReactGA.event({
            category: "Order in stationary page",
            action: "Click",
            value: ``,
          });
          setStationaryCart([]);
          navigate(`/${room_uuid}/HKOrderPlaced`);
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: t(`${res?.data?.message || "Something went wrong"}`),
            life: 4000,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        setIsDisabled(false);
        console.log(err);
      });
  };

  return (
    <>
      <HeaderInner headerName={title} />
      <main className="bg-white back-white laundry_page">
        <Toast ref={toast} position="bottom-center" />

        {stationaryCart.map((item, idx) => (
          <div
            key={`${item.id}-${idx}`}
            className="add-post-container add-cart mt-4"
          >
            <div className="add-cart-post laun-pay new spa gray">
              <div className="add-cart-post-inner">
                <div className="cross-btn-red" onClick={() => removeItem(item)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 23 23"
                  >
                    <path
                      d="M14.875,3.375a11.5,11.5,0,1,0,11.5,11.5A11.5,11.5,0,0,0,14.875,3.375Zm2.914,15.663-2.914-2.914-2.914,2.914a.884.884,0,1,1-1.25-1.25l2.914-2.914-2.914-2.914a.884.884,0,0,1,1.25-1.25l2.914,2.914,2.914-2.914a.884.884,0,0,1,1.25,1.25l-2.914,2.914,2.914,2.914a.888.888,0,0,1,0,1.25A.878.878,0,0,1,17.789,19.038Z"
                      transform="translate(-3.375 -3.375)"
                      fill="#f11027"
                    ></path>
                  </svg>
                </div>
                <span className="img-pnl navigate">
                  {/* <img
                    src={
                      item.image || "https://via.placeholder.com/100?text=Item"
                    }
                    alt="Post"
                    className="box-service-img"
                  /> */}
                </span>
                <div className="txt-pnl navigate">
                  <h2>{item.name}</h2>
                  <div className="flex-div align-item-center">
                    <h3>{item.category || t("Stationary")}</h3>
                    <Button
                      className="reg-btn v2 service"
                      onClick={() => changeItem(item)}
                    >
                      {t("Change")}
                    </Button>
                  </div>
                  <p>
                    {t("Qty")}: {item.quantity}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}

        {serviceFee != 0 && (
          <div
            className="full-heading flex order-total"
            style={{ marginBottom: "-14px" }}
          >
            <p>{t("Service Fee")}</p>
            <p>
              <Currency currency={currency} /> {serviceFee}
            </p>
          </div>
        )}

        {discountPercentage != 0 && (
          <div
            className="full-heading flex order-total"
            style={{ marginBottom: "-14px" }}
          >
            <p>{t("Discount Percentage")}</p>
            <p>{discountPercentage}%</p>
          </div>
        )}

        {vat != 0 && (
          <div
            className="full-heading flex order-total"
            style={{ marginBottom: "-14px" }}
          >
            <p>{t("VAT")}</p>
            <p>{vat}%</p>
          </div>
        )}

        <div className="full-heading flex m-0 order-total mb-2">
          <p>{t("Order Total")}</p>
          <span className="d-flex">
            {discountPercentage != 0 && (
              <p className="laundry_discount_percentage">
                <Currency currency={currency} /> {discountedSubTotal.toFixed(2)}
              </p>
            )}
            <p
              className={
                discountPercentage != 0
                  ? "laundry_pasic_price"
                  : "laundry_discount_percentage"
              }
            >
              <Currency currency={currency} /> {finalTotal.toFixed(2)}
            </p>
          </span>
        </div>

        <div className="full-div padd-div px-4">
          <Link
            className="reg-btn big w-100 more-items px-4"
            onClick={addMoreItem}
          >
            <i className="fa fa-plus-square"></i>
            <span>{`${t("Add More Items")}`}</span>
            <span></span>
          </Link>
        </div>

        <div className="padd-div">
          <Form onSubmit={handleBook}>
            <Form.Group className="mb-3" controlId="stationaryRoomNumber">
              <Form.Control
                type="text"
                value={`${t("Room number")} ${room_number || ""}`}
                disabled={true}
              />
            </Form.Group>

            {/* <Form.Group
              className="mb-3 dark-placeholder"
              controlId="stationaryName"
            >
              <Form.Control
                type="text"
                placeholder={t("Your Name (Optional)")}
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
            </Form.Group> */}

            {/* <Form.Group
              className="mb-3 dark-placeholder"
              controlId="stationaryEmail"
            >
              <Form.Control
                type="email"
                placeholder={t("Your Email (Optional)")}
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </Form.Group> */}

            {/* <Form.Group className="mb-3 w-100" controlId="stationaryPhone">
              <PhoneInputComponent
                value={formData.phone}
                onChange={(phone) => {
                  setFormData((prev) => ({
                    ...prev,
                    phone,
                  }));
                }}
              />
            </Form.Group> */}

            {/* <div
              className="d-flex align-items-center"
              style={{ color: "#000000" }}
            >
              <input
                type="checkbox"
                checked={termsAccepted}
                onChange={() => setTermsAccepted((prev) => !prev)}
              />
              <span
                onClick={() => setShowTerms(true)}
                style={{
                  color: "black",
                  marginLeft: "8px",
                  marginRight: "8px",
                  cursor: "pointer",
                }}
              >
                {t("I agree to")}{" "}
                <span
                  style={{
                    textDecoration: "underline",
                    textDecorationColor: "black",
                    color: "black",
                  }}
                >
                  {t("terms and conditions")}
                </span>
              </span>
            </div> */}

            <div className="spacer-40"></div>
            <div className="padd-div text-center mt-3">
              <Button
                type="submit"
                className="reg-btn order-btn"
                disabled={isDisabled || loading}
              >
                {loading ? t("Please wait...") : t("Order")}
              </Button>
            </div>
          </Form>
        </div>

        <div className="padd-div text-center mb-70">
          <h3>{/* <TaxInclusive /> */}</h3>
        </div>

        <ViewStationaryCartModal
          show={show}
          handleClose={handleClose}
          services={services}
          itemChange={itemChange}
          images={images}
        />

        <Modal
          show={openMin}
          onHide={handleCloseMin}
          className="laundary-modal custom-width b-r"
          style={{ marginTop: "200px" }}
        >
          <Modal.Body
            style={{
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <p className="order-model">
              {t("Order amount must be at least")}{" "}
              <Currency currency={currency} /> ({minAmount})
            </p>
            <Button onClick={handleCloseMin} className="reg-btn v2 service">
              {t("OK")}
            </Button>
          </Modal.Body>
        </Modal>

        <Modal
          show={showTerms}
          onHide={handleTermsClose}
          className="custom-width lay_pref"
        >
          <Modal.Body className="p-4">
            <h2>{t("Terms and Conditions")}</h2>
            <Accordion
              multiple
              activeIndex={[0]}
              expandIcon="fa fa-plus"
              collapseIcon="fa fa-minus"
              className="mb-4"
            >
              {disclaimerHtml ? (
                <AccordionTab header={t("Disclaimer")}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: disclaimerHtml,
                    }}
                  />
                </AccordionTab>
              ) : null}
              {termsHtml ? (
                <AccordionTab header={t("Terms and Conditions")}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: termsHtml,
                    }}
                  />
                </AccordionTab>
              ) : null}
            </Accordion>
            <Row className="mt-4">
              <Col lg="12" md="12" xs="12" className="p-0 px-2">
                <Button
                  className="reg-btn big laundary-btn mb-0"
                  onClick={handleTermsClose}
                >
                  {t("Close")}
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </main>
    </>
  );
}

export default StationaryOrderPayment;
